// extracted by mini-css-extract-plugin
module.exports = {"container":"_1GuW0Ykh9Wpp0awvCOfpUb"};